const types = {
    SET_USERS: "SET_USERS",
    SET_LOADING: 'SET_LOADING',
    SET_CLEARED: 'SET_CLEARED',
    SET_SEARCH: 'SET_SEARCH',
    SET_USER_DETAILS: 'SET_USER_DETAILS',
    SET_REPOS: 'SET_REPOS',
    SET_IS_BLANK: 'SET_IS_BLANK',
}
export default types;